import { render } from "./TbRegister.vue?vue&type=template&id=98d80d46&scoped=true"
import script from "./TbRegister.vue?vue&type=script&lang=js"
export * from "./TbRegister.vue?vue&type=script&lang=js"

import "./TbRegister.vue?vue&type=style&index=0&id=98d80d46&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d80d46"]])

export default __exports__